import { render, staticRenderFns } from "./ShipmentCardComponent.vue?vue&type=template&id=0f3ab1f9&scoped=true&"
import script from "./ShipmentCardComponent.vue?vue&type=script&lang=js&"
export * from "./ShipmentCardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3ab1f9",
  null
  
)

export default component.exports